/**
 * Shared ISO 3166-2 subdivision parsing (e.g. US-CA, AU-NSW).
 */

export interface SubdivisionParts {
	country: string
	region: string
}

/**
 * Parses ISO 3166-2 subdivision string into country and region.
 * E.g. 'US-CA' → { country: 'US', region: 'CA' }; '' → { country: '', region: '' }
 */
export function subdivisionToCountryRegion(subdivision: string): SubdivisionParts {
	const [country, region] = subdivision.split('-')
	return { country: country ?? '', region: region ?? '' }
}

/** Extracts country code from subdivision. Convenience for callers that only need country. */
export function subdivisionToCountry(subdivision: string): string {
	return subdivisionToCountryRegion(subdivision).country
}
